import { ErrorCode, PaymentType } from '@ace-clublabs/payment-types';

export interface IFieldError {
  isNotValid?: boolean;
  isRequired?: boolean;
  isMinLength?: boolean;
  isMaxLength?: boolean;
}

export interface ICardFormFieldChange {
  empty: boolean;
  field: string;
  length: number;
  potentiallyValid: boolean;
  selector: string;
  touched: boolean;
  valid: boolean;
}
export interface ICardFormFieldBlur {
  field: string;
  selector: string;
}

export interface ICardFormState {
  [key: string]: ICardFormFieldChange;
}

export enum FieldErrorType {
  None,
  IsNotValid,
  IsRequired,
  IsMinLength,
  IsMaxLength,
}

export interface IFieldError {
  type: FieldErrorType;
  message?: string;
}
